import Askeleton from '@/components/Askeleton';
import './index.css';

export default {
  name: 'Abody',
  props: {
    loading: { type: Boolean, default: () => false },
    flex: { type: Boolean, default: () => true },
  },
  data() {
    return ({
      mounted: false,
    });
  },
  watch: {
    loading() {
      this.mounted = true;
    },
  },
  render() {
    const { title = null, margin = '0', padding = '12px', background } = this.$attrs;
    return (
      <div class={['a-body', (this.flex ? 'flex' : null)]} style={{ margin: (`${parseInt(margin)}px`), background }}>
        <div class="a-body-main" style={{ padding: (`${parseInt(padding)}px`) }}>
          <div class={['a-body-container', (this.loading && (!this.mounted ? 'loading' : null))]}>
            {(this.$slots.header || title) && (
              <div class="a-body-header">
                {title && (<h3 class="a-body-header-title">{title}</h3>)}
                {this.$slots.header}
              </div>
            )}
            {this.$slots.default && (
              <div class="a-body-center">
                {this.$slots.default}
              </div>
            )}
            {this.$slots.footer && (<div class="a-body-footer">{this.$slots.footer}</div>)}
          </div>
          <div class={['a-body-loading', (this.loading && (!this.mounted ? 'loading' : null))]} style={{ padding: (`${parseInt(padding)}px`) }}>
            <Askeleton />
          </div>
        </div>
      </div>
    );
  }
}